import { FC } from 'react'
import { useSelector } from 'react-redux'

import { Button } from 'core-components/library/button'
import { selectPublishingMode } from 'core/store/selectors/selectPublishingMode'

import styles from './ContactControls.module.scss'

interface IContactControlsProps {
  hideControls: boolean
  isContactEditing: boolean
  onEdit?: () => void
  onDelete?: () => void
  onSave?: () => void
  onCancelEditing: () => void
}

export const ContactControls: FC<IContactControlsProps> = ({
  hideControls,
  isContactEditing,
  onEdit,
  onDelete,
  onSave,
  onCancelEditing,
}) => {
  const isEditMode = useSelector(selectPublishingMode)

  if (hideControls) {
    return null
  }

  if (isContactEditing) {
    return (
      <div className={styles.root}>
        <Button
          variant="text"
          color="grey"
          onClick={onCancelEditing}
          iconButton="kbase kbase-close"
        />
        <Button variant="text" color="grey" onClick={onSave} iconButton="kbase kbase-check" />
      </div>
    )
  }

  if (isEditMode) {
    return (
      <div className={styles.root}>
        <Button
          iconButton="kbase kbase-delete kbase-sm"
          variant="text"
          color="grey"
          onClick={onDelete}
        />
        <Button
          iconButton="kbase kbase-edit kbase-sm"
          variant="text"
          color="grey"
          onClick={onEdit}
        />
      </div>
    )
  }

  return null
}
